import { Navigate, Route, Routes } from 'react-router-dom';
import {
  InvoiceDetailPage,
  InvoiceFormPage,
  InvoicesListPage,
} from '@/modules/billing/pages';
import { billingPaths } from '@/modules/billing/paths';

export function BillingModule() {
  return (
    <Routes>
      <Route index element={<Navigate to={billingPaths.invoices} replace />} />
      <Route path={billingPaths.invoices} element={<InvoicesListPage />} />
      <Route path={billingPaths.invoiceNew} element={<InvoiceFormPage />} />
      <Route
        path={`${billingPaths.invoiceDetail}/editar`}
        element={<InvoiceFormPage />}
      />
      <Route path={billingPaths.invoiceDetail} element={<InvoiceDetailPage />} />
    </Routes>
  );
}
